export default __webpack_public_path__ + "maps-examples-clustering-thumbnail-480-4f034eae297803f0c24dd410cd47c81a.png";